import {CodeInput} from "@/components/inputs";
import {useEffect, useState} from "react";
import {fetchData, isEmpty} from "@/utils/global-functions";
import {REQ_TYPES} from "@/constants/general-constants";
import {toast} from "react-toastify";
import {Countdown} from "@/components";
import Cookies from "js-cookie";
import {useRouter} from 'next/router'
import {useDispatch} from "react-redux";
import {login} from "@/redux/slices/user-slice";

export default function ConfirmCodeForm({checkData = {}, onPrev, userType = 1}) {

    const [code, setCode] = useState("");
    const [resendTimer, setResendTimer] = useState(0);
    const router = useRouter();

    const dispatch = useDispatch()

    useEffect(() => {
        if (checkData.remaining_till_resend) {
            setResendTimer(checkData.remaining_till_resend)
        }
    }, [checkData.remaining_till_resend]);

    const changeHandler = ({target: {value}}) => {
        setCode(value)
    }

    const verifyCode = async (e) => {
        e.preventDefault();

        if (!code) {
            toast.error("کد نامعتبر")
            return false;
        }
        const verifyData = await fetchData("auth/verify", REQ_TYPES.POST, {
            mobile: checkData.mobile,
            verify_code: code,
            user_type: userType
        });

        if (!verifyData.error) {
            toast.success("خوش آمدید!");
            // Cookies.set(process.env.NEXT_PUBLIC_FREELANCER_TOK, verifyData.data.data.token, {
            //     expires: 31,
            // });
            Cookies.set(process.env.NEXT_PUBLIC_FREELANCER_TOK, verifyData.data.data.token, {
                expires: 31,
                domain: `.${process.env.NEXT_PUBLIC_MAIN_URL}`
            });
            dispatch(login());

            if (router.query.url) {
                await router.replace(router.query.url);
            } else {
                await window.location.replace(`${userType === 1 ? process.env.NEXT_PUBLIC_FREELANCER_URL : process.env.NEXT_PUBLIC_EMPLOYER_URL}`);
            }
        }
    }

    const resendCode = async () => {
        const resendData = await fetchData("auth/check", REQ_TYPES.POST, {mobile: checkData.mobile});
        if (!resendData.error) {
            toast.success("کد تایید مجدد ارسال شد!");
            if (!isEmpty(resendData.data) && resendData.data.data.remaining_till_resend) {
                setResendTimer(resendData.data.data.remaining_till_resend)
            }
        }
    }

    const onTimerFinished = () => {
        setResendTimer(0)
    }

    return (
        <div className="text-center">
            <h2 className="font-bold text-xl">کد تایید</h2>

            <form className="mt-[3.125rem] sm:px-[2.375rem]" onSubmit={verifyCode}>
                <CodeInput
                    label={`کد تایید ارسال شده از طریق پیامک و بله به شماره ${checkData.mobile} را وارد کنید.`}
                    value={code}
                    name="code"
                    onChange={changeHandler}
                    classes={{
                        labelClasses: "mr-0 text-pol-dark-800 mb-4",
                        inputClasses: "bg-pol-light-7 text-center font-semibold"
                    }}/>
                <button
                    type="submit"
                    className="btn-dark w-full font-semibold text-sm py-[0.815rem] mt-[1.125rem]"
                >
                    ثبت و ادامه
                </button>
            </form>
            {
                resendTimer ?
                    <p className="text-sm font-semibold mt-6 text-pol-light-brown">
                        <Countdown
                            timer={resendTimer}
                            onFinish={onTimerFinished}
                        />
                        <span> تا ارسال مجدد</span>
                    </p> :
                    <button
                        onClick={resendCode}
                        className="text-sm font-semibold mt-6 text-pol-blue"
                    >
                        <i className="icon-simple-arrow-left ml-2.5"/>
                        <span>ارسال مجدد کد</span>
                    </button>
            }
            <span className="block w-full bg-pol-blue-light h-px mt-[3.125rem]"/>

            <div className="sm:px-[2.375rem] mt-7">
                <button
                    onClick={onPrev}
                    className="flex items-center justify-center py-4 border border-pol-dark w-full font-semibold rounded-[0.875rem] text-sm text-pol-dark">
                    ویرایش شماره همراه
                </button>
            </div>
        </div>
    )
}
